import styled from "styled-components";

export const Wrapper = styled.div``;
export const Flex = styled.div`
  display: flex;
`;
export const HSeparator = styled.div`
  margin: 0px 5px;
`;
